/** Works with both Wouter's relative location and a full market pathname. */
export function searchResultsPath(pathname = ""): string {
  const path = pathname.split(/[?#]/, 1)[0].replace(/\/+$/, "");
  return /^(?:\/[a-z]{2}(?:\/[a-z]{2})?)?\/cars$/.test(path) ? path : "/search";
}
